import MemberIcon from "assets/icons/member.svg";
import MembersIcon from "assets/icons/members.svg";
import React from 'react';
import { EmptyLoadingParticipantContainer, ParticipantMember, ParticipantMemberIcon, ParticipantMemberName, ParticipantMemberNumber, ParticipantMembers, ParticipantMenuItem, ParticipantMenuItemHead, ParticipantMenuItemIcon, ParticipantMenuItemName, ParticipantMenuList } from './Theme';

const AddParticipantModalMembers = ({
  members,
  isLoading,
  selectParticipantHandler,
  activeParticipant,
  participantsRef
}) => {

  const checkActiveParticipant = (accountId, memberId) => {
    return activeParticipant?.id === accountId && activeParticipant?.memberId === memberId;
  }

  return (
    <ParticipantMenuList
      ref={participantsRef}
    >
      {isLoading ? <EmptyLoadingParticipantContainer>
        Loading...
      </EmptyLoadingParticipantContainer>
        : members?.length ? members?.map((member) => (
          <ParticipantMenuItem
            key={member?._id}
          >
            <ParticipantMenuItemHead>
              <ParticipantMenuItemIcon>
                <img src={MembersIcon} alt="" />
              </ParticipantMenuItemIcon>
              <ParticipantMenuItemName>
                {member?.familyName !== "undefined undefined" ? member?.familyName : ""} 
              </ParticipantMenuItemName>
              <ParticipantMenuItemName>{member?.totalMembers} Members</ParticipantMenuItemName>
            </ParticipantMenuItemHead>
            <ParticipantMembers>
              {member?.familyMembers?.map((item) => (
                <ParticipantMember
                  key={item?.id}
                  isDisabled={item?.disable}
                  onClick={() => {
                    if (item?.disable) return;
                    selectParticipantHandler(item, member?._id)
                  }}
                  isActive={checkActiveParticipant(item?.id, member?._id)}
                >
                  <ParticipantMemberIcon>
                    <img src={MemberIcon} alt="" />
                  </ParticipantMemberIcon>
                  <ParticipantMemberName
                    className="participant-member-name"
                  >{item?.first_name} {item?.last_name}</ParticipantMemberName>
                  <ParticipantMemberNumber
                    className="participant-member-number"
                  >#{item?.member_id}</ParticipantMemberNumber>
                </ParticipantMember>
              ))}
            </ParticipantMembers>
          </ParticipantMenuItem>
        )) : <EmptyLoadingParticipantContainer>
          No Options
        </EmptyLoadingParticipantContainer>
      }
    </ParticipantMenuList>
  )
}

export default AddParticipantModalMembers